// extracted by mini-css-extract-plugin
export default {"chatContainer":"GenAiChat_chatContainer__1O8mK","footer":"GenAiChat_footer__1tGJT","resizeHandle":"GenAiChat_resizeHandle__35p4a"};